var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"slide-fade","duration":_vm.duration,"appear":""},on:{"after-enter":_vm.enterEnd}},[(_vm.show)?_c('div',{ref:"mask",staticClass:"dialog-swipe modal",class:{
            'modal--left': _vm.isLeft,
            'modal--bottom': _vm.isBottom,
            'modal--fullscreen': _vm.fullscreen,
            'modal--no-mask': _vm.noMask
        },attrs:{"tabindex":"0"},on:{"click":_vm.close,"touchstart":_vm.swipeStart,"&touchmove":function($event){return _vm.touchmove.apply(null, arguments)},"touchend":_vm.swipeEnd}},[_c('div',{ref:"dialog",staticClass:"modal__body",class:{ 'p-0': _vm.noGutters }},[_vm._t("default")],2)]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }